import { Lang } from 'Roblox';
import angular from 'angular';

let chat = angular
    .module("chat", ["robloxApp", "monospaced.elastic", "modal", "ui.bootstrap.popover", "toast"])
    .config(['msdElasticConfig', 'languageResourceProvider', function (msdElasticConfig, languageResourceProvider) {
        msdElasticConfig.append = "\n";
        if (Lang.ChatResources) {
            languageResourceProvider.setLanguageKeysFromFile(Lang.ChatResources);
        }
    }]);

export default chat;



